import APIUtils from '@spothero/utils/api';

const AddressAPI = {
    getStateOptions() {
        const config = {
            headers: {'SpotHero-Version': '2018-10-01'},
        };

        return APIUtils.get('states/', null, config);
    },
};

export default AddressAPI;
